import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { Button, Input, Table, Form, Popconfirm, Typography, Modal, Empty } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { getStyle, getBizID, getObjective, getServices } from '../../../libs/todoSlice'
import {
    getHistoryDetail, setHistoryDetail, setHistorySuccessIncrease, setHistoryFailToSuccess,
    getMemberOneFailRedux, setMemberOneFailRedux, setMemberSuccessRedux, getMemberSuccessRedux,
    setMemberFailRedux, getMemberFailRedux, getHistoryFailDataRedux, setHistoryFailDataRedux,
    setHistoryFailDataLoadingWithIndexRedux,
} from '../../../libs/historySlice';
import LoadingComponent from "../../../lib/LoadingComponent";
import fontColor from "../../../lib/fontColor";
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import axios from "axios";
import { resolveNoteText } from "../../../lib/errorKeyNote";
import { retryPreRegisterItems } from "../../../lib/callAgainPreRegister";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { resolvePreRegisterConfig, buildFieldColumns, buildEmptyFormValues } from '../../../lib/preRegisterConfig';

/**
 * Generic — แทน ThaIDHistoryDetailFail.jsx
 * ใช้ config.fields จาก preRegisterConfig.jsx เพื่อ derive columns/edit form
 * ตามประเภทที่กำลังใช้งานอยู่ (thaid / thaidGeneralForm / ประเภทอื่นในอนาคต)
 */
const PreRegisterHistoryDetailFail = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()

    const details = useSelector(getHistoryDetail)
    const setDetails = (action) => dispatch(setHistoryDetail({ historydetail: action }))

    const style = useSelector(getStyle)
    const business_id = useSelector(getBizID)
    const services = useSelector(getServices)
    const lastHistory = details.importHistories[details.importHistories.length - 1]
    const objective = lastHistory.objective ?? []
    const config = resolvePreRegisterConfig(lastHistory.objective ?? [])
    const [form] = Form.useForm();

    const [modalNote, setModalNote] = useState(false)
    const [noteTXT, setNoteTXT] = useState([])
    const [loading, setLoading] = useState(false)

    const data = useSelector(getHistoryFailDataRedux)
    const setData = (action) => dispatch(setHistoryFailDataRedux({ historyFailData: action }))

    const memberOneFail = useSelector(getMemberOneFailRedux)
    const setMemberOneFail = (action) => dispatch(setMemberOneFailRedux({ memberOneFail: action }))

    const memberSuccess = useSelector(getMemberSuccessRedux)
    const setMemberSuccess = (action) => dispatch(setMemberSuccessRedux({ memberSuccess: action }))

    const member_fail = useSelector(getMemberFailRedux)
    const setMemberFail = (action) => dispatch(setMemberFailRedux({ member_fail: action }))

    const [fileID, setFileID] = useState('');
    const [modalbeforeSuccess, setModalBeforeSuccess] = useState(false);
    const [lastRetryResult, setLastRetryResult] = useState({ success: 0, fail: 0 });

    const alertManagement = (successCount, failCount) => {
        const message = `ข้อมูล Pre Registration ด้วย ${config.entityLabel}`
        if (successCount !== 0 && failCount !== 0) {
            return (<>สร้าง {message} สำเร็จ {successCount} รายการ<br />ไม่สำเร็จ {failCount} รายการ</>)
        }
        if (successCount !== 0) {
            return (<>สร้าง {message} แล้ว {successCount} รายการ</>)
        }
        return (<>ไม่สามารถสร้าง {message} ได้ {failCount} รายการ</>)
    }

    const prepareData = () => {
        const lastHistory = details.importHistories[details.importHistories.length - 1]
        setData(lastHistory.failDetail.map((items, index) => ({
            key: items.request.key,
            index: index,
            loading: false,
            ...Object.fromEntries(config.fields.map(f => [f.key, items.request[f.key] ?? '-'])),
            response: items.response,
        })))
        setMemberOneFail(lastHistory.failDetail)
        setMemberFail(lastHistory.failDetail)
        setMemberSuccess(lastHistory.successDetail)
        setFileID(details._id)
    }

    useEffect(() => {
        
        prepareData()
    }, [details, config])

    const handleRetry = async () => {
        setLoading(true)

        const successResults = []
        const failResults = []

        await retryPreRegisterItems({
            keys: stateBtnAgain,
            memberOneFail,
            objective,
            business_id,
            file_id: fileID,
            services,
            onItemStart: (key) => {
                const index = memberOneFail.findIndex((m) => m.request.key === key)
                if (index !== -1) {
                    dispatch(setHistoryFailDataLoadingWithIndexRedux({ loading: true, index }))
                }
            },
            onItemSuccess: (key, result) => {
                successResults.push(result)
                dispatch(setHistorySuccessIncrease())
                dispatch(setHistoryFailToSuccess({ index: result.request.index, detail: result }))
            },
            onItemFail: (key, result) => {
                failResults.push(result)
            },
        })

        const successKeys = successResults.map((r) => r.request.key)
        const success_summary = [...memberSuccess, ...successResults]
        const fail_summary = memberOneFail
            .filter((member) => !successKeys.includes(member.request.key))
            .map((member) => {
                const failed = failResults.find((f) => f.request.key === member.request.key)
                return failed || member
            })

        await sendExcelSummary(success_summary, fail_summary)
        setMemberSuccess(success_summary)
        setMemberFail(fail_summary)
        setMemberOneFail(fail_summary)

        setDetails({
            ...details,
            importHistories: [
                {
                    ...details.importHistories[details.importHistories.length - 1],
                    failDetail: fail_summary,
                    successDetail: success_summary,
                }
            ]
        })
        setLastRetryResult({ success: successResults.length, fail: failResults.length })
        setStateBtnAgain([])
        setLoading(false)
        setModalBeforeSuccess(true)
    }

    // function edit
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({ ...buildEmptyFormValues(config), ...record });
        setEditingKey(record.key);
    };
    const cancel = () => setEditingKey('');
    const save = async (key) => {
        setStateBtnAgain([])
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.index);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, { ...item, ...row });
                setData(newData);
                setMemberFail(newData.map((d) => ({ request: d, response: d.response })))
                setMemberOneFail(newData.map((d) => ({ request: d, response: d.response })))
                setDetails({
                    ...details,
                    importHistories: [
                        {
                            ...details.importHistories[details.importHistories.length - 1],
                            failDetail: details.importHistories[details.importHistories.length - 1].failDetail.map((fail, loopIndex) => {
                                const tempFail = { ...fail }
                                if (loopIndex === index) {
                                    // id_card_type เป็น select type ที่ไม่ผ่าน antd form (row จะไม่มีค่านี้)
                                    // จึงต้องคง id_card_type จาก item ไว้เสมอ ไม่ให้ถูก row เขียนทับด้วยค่าว่าง
                                    tempFail.request = { ...tempFail.request, ...row, id_card_type: item.id_card_type }
                                }
                                return tempFail
                            })
                        }
                    ]
                })
                setEditingKey('');
            }
        } catch (errInfo) {
        }
    };
    const handleDelete = (key) => {
        const newData = data.filter((item) => item.key !== key);
        setData(newData);
        setMemberFail(newData.map((item) => ({ request: item, response: item.response })))
    };

    // start select row
    const [stateBtnAgain, setStateBtnAgain] = useState([]);
    const rowSelection = {
        selectedRowKeys: stateBtnAgain,
        onChange: (selectedRowKeys) => setStateBtnAgain(selectedRowKeys),
        getCheckboxProps: () => ({ disabled: loading }),
    };
    // end select row

    // function add fail or success to history
    const sendExcelSummary = async (success, fail) => {
        await axios({
            method: 'PATCH',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
            data: {
                _id: fileID,
                total: (success.length + fail.length).toString(),
                success: `${success.length}`,
                fail: `${fail.length}`,
                successDetail: success,
                objective: objective,
                failDetail: fail
            }
        }).then(() => {
        }, ({ response }) => {
            const { status } = response
            if (status === 401) {
                navigate(`/${params.prefix}`)
            }
        })
    }
    // end function add fail or success to history

    const fieldColumns = buildFieldColumns(config, { editable: true, isEditing, data, setData })

    const columns = [
        {
            title: 'ลำดับที่',
            width: 100,
            render: (_, __, index) => index + 1,
        },
        ...fieldColumns,
        {
            title: 'operation',
            dataIndex: 'operation',
            width: 220,
            fixed: 'right',
            render: (_, record, index) => {
                const editable = isEditing(record);
                return record.loading ? <LoadingComponent width={80} height={80} /> : editable ? (
                    <span>
                        <Button
                            type='primary'
                            disabled={loading}
                            onClick={() => save(record.index)}
                            style={{ marginRight: 8, background: '#53BE35' }}
                        >
                            บันทึก
                        </Button>
                        <Popconfirm title="Sure to cancel?" disabled={loading} onConfirm={cancel}>
                            ยกเลิก
                        </Popconfirm>
                    </span>
                ) : (
                    <>
                        <Typography.Link disabled={editingKey !== '' || loading} onClick={() => edit(record)}>
                            <ModeEditOutlinedIcon style={{ color: style.primary_color ?? '#053075' }} />
                        </Typography.Link> &nbsp;
                        <Button size='large'
                            disabled={loading}
                            style={{ backgroundColor: '#F8F9FA', color: '#053075' }}
                            onClick={() => {
                                setModalNote(true)
                                setNoteTXT(resolveNoteText(record.response?.message))
                            }}>
                            หมายเหตุ
                        </Button>
                    </>
                );
            },
        },
    ];

    const customLocale = {
        emptyText: (<Empty description="ไม่มีข้อมูล" />)
    };

    return (
      <>
        <Row>
          <Col className="d-flex justify-content-end">
            {stateBtnAgain.length != 0 && (
              <Button
                type="primary"
                style={{
                  background: style.secondary_color ?? "#053075",
                  color: style.secondary_color
                    ? fontColor(style.secondary_color)
                    : "#FFFFFF",
                }}
                disabled={loading}
                onClick={handleRetry}
              >
                <AutorenewIcon /> ดำเนินการสร้างอีกครั้ง
              </Button>
            )}
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Form form={form} component={false}>
            <Table
              locale={customLocale}
              bordered
              dataSource={data}
              columns={columns}
              rowClassName="editable-row"
              pagination={{ onChange: cancel }}
              scroll={{ x: 900, y: 400 }}
              rowSelection={{ type: "checkbox", ...rowSelection }}
            />
          </Form>
          <Modal
            title="หมายเหตุ"
            centered
            open={modalNote}
            footer={null}
            onCancel={() => setModalNote(false)}
          >
            {noteTXT.map(
              (notes, i) =>
                notes && (
                  <span key={i}>
                    <ul>
                      <li>{JSON.stringify(notes).replaceAll('"', "")}</li>
                    </ul>
                  </span>
                ),
            )}
          </Modal>
          <Modal
            title={
              lastRetryResult.success !== 0
                ? "ทำรายการสำเร็จ"
                : "ทำรายการไม่สำเร็จ"
            }
            centered
            open={modalbeforeSuccess}
            onOk={() => setModalBeforeSuccess(false)}
            onCancel={() => setModalBeforeSuccess(false)}
            footer={null}
          >
            <Row>
              <Col className="d-flex justify-content-center">
                {lastRetryResult.success !== 0 ? (
                  <CheckIcon
                    style={{
                      background: "#53BE35",
                      borderRadius: "50%",
                      fontSize: "50px",
                      color: "#fff",
                      padding: "10px",
                    }}
                  />
                ) : (
                  <CloseIcon
                    style={{
                      background: "#F37959",
                      borderRadius: "50%",
                      fontSize: "50px",
                      color: "#fff",
                      padding: "10px",
                    }}
                  />
                )}
              </Col>
            </Row>
            <Row style={{ paddingTop: "30px", paddingBottom: "30px" }}>
              <Col className="d-flex justify-content-center">
                {alertManagement(lastRetryResult.success, lastRetryResult.fail)}
              </Col>
            </Row>
          </Modal>
        </Row>
      </>
    );
}
export default PreRegisterHistoryDetailFail